/**
 * Could a failed request have REACHED the server?
 *
 * The offline queue's local undo turns on this (offline-mode spec §5): a scan
 * the server may hold can only be undone through the server, while one whose
 * connection never opened is the operator's to take back.
 *
 * - A connection that never opened (no route, refused, DNS, the device offline)
 *   cannot have been received: axios reports ERR_NETWORK with no response.
 * - A timeout was sent and simply never answered — the server may well have
 *   committed it.
 * - Any answer at all (a 5xx, a 429) means the server received it.
 * Unknown shapes count as "may have reached", the safe side.
 */
export function mayHaveReachedServer(err: unknown): boolean {
  const e = err as { connectionFailed?: boolean; status?: number } | null | undefined;
  if (e?.connectionFailed === true) return false;
  return true;
}

/** Axios's shape for "the connection itself never opened". */
export function isConnectionFailure(error: {
  code?: string;
  message?: string;
  response?: unknown;
}): boolean {
  if (error.response) return false;
  // ECONNABORTED / ETIMEDOUT are a request that went out and timed out; the
  // server may have processed it. ERR_NETWORK is a connection that never was.
  return error.code === 'ERR_NETWORK' || error.code === 'ERR_INTERNET_DISCONNECTED';
}
